import { createFileRoute } from "@tanstack/react-router";
import { listSearch } from "../../../shared/utils/pagination-search";
import { RouteError } from "../../../shared/components/RouteError";

/**
 * @purpose REP: track open repairs at my locations and report new ones
 * @purpose WAR: track warranty cases and act on those awaiting me
 * @purpose MAT: review material orders for my locations and create new ones
 * @primary Orders/requests table
 * @persona sports-manager-ikos, paola-admin-belora, mecanico-externo, procurement
 */
export const Route = createFileRoute("/app/c/$customerSlug/d/$docTypeSlug/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  validateSearch: listSearch,
});
